import { createSlice } from '@reduxjs/toolkit';
import { Transaction, TransactionWithBal } from 'src/types';
import * as thunks from './thunks';

type State = {
  transactions: Transaction[];
  transactionsWithBal: TransactionWithBal[];
  isCreateLoading: boolean;
  isTransactionSalesLoading: boolean;
};

const initialState: State = {
  transactions: [],
  transactionsWithBal: [],
  isCreateLoading: false,
  isTransactionSalesLoading: false
};

const slice = createSlice({
  name: 'transactions',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(
      thunks.getTransactionsThunk.fulfilled,
      (state, { payload }) => {
        state.transactions = payload.originalData.transactions || [];
      }
    );

    builder.addCase(thunks.getTransactionsWithBalanceThunk.pending, (state) => {
      state.isTransactionSalesLoading = true;
    });

    builder.addCase(
      thunks.getTransactionsWithBalanceThunk.rejected,
      (state) => {
        state.isTransactionSalesLoading = false;
      }
    );

    builder.addCase(
      thunks.getTransactionsWithBalanceThunk.fulfilled,
      (state, { payload }) => {
        state.transactionsWithBal = payload.originalData.data || [];
        state.isTransactionSalesLoading = false;
      }
    );

    builder.addCase(thunks.createTransactionThunk.pending, (state) => {
      state.isCreateLoading = true;
    });
    builder.addCase(thunks.createTransactionThunk.rejected, (state) => {
      state.isCreateLoading = false;
    });
    builder.addCase(thunks.createTransactionThunk.fulfilled, (state) => {
      state.isCreateLoading = false;
    });
  }
});

export const reducer = slice.reducer;

export const actions = {
  ...slice.actions,
  ...thunks
};
